import React from 'react';
import {
  Col, Divider, Form, Input, Row,
} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import ResetFieldButton from '../../../../Common/ResetFieldButton';

/* eslint-disable max-len */
const defaultValues = {
  title: 'Was garantieren wir Dir?',
  description: 'Du bekommst von uns 5 Jahre Ganatie auf Deinen Energiepreis von 8,25 ct/kWh.\n'
    + '\n'
    + 'In den ersten 18 Monaten hast du zusätzlich eine eingeschränkte Preisgarantie auf deinen gesamten Arbeitspreis. Hier wird sich Dein preis pro kWh nicht erhöhen.\n'
    + '\n'
    + 'In den restlichen 42 Monaten können sich die Netzentgelte, Steuern und Gebühren erhöhen. Auf diese Kosten haben wir keinen Einfluss. Dein Energiepreis von 8,25 ct/kWh bleibt weiterhin bestehen.',
};

const prefixArr = ['tooltips', 'guaranties'];

function GuarantiesTextFields() {
  const form = useFormInstance();

  return (
    <>
      <Divider />
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item
            label={(
              <div className="centered-content">
                Popup title
                <ResetFieldButton onClick={() => form.setFieldValue([...prefixArr, 'title'], defaultValues.title)} />
              </div>
            )}
            name={[...prefixArr, 'title']}
            rules={[{ required: false, message: 'Please enter' }]}
          >
            <Input placeholder="Please enter" />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item
            label={(
              <div className="centered-content">
                Popup description
                <ResetFieldButton onClick={() => form.setFieldValue([...prefixArr, 'description'], defaultValues.description)} />
              </div>
            )}
            name={[...prefixArr, 'description']}
            rules={[{ required: false, message: 'Please enter' }]}
          >
            <Input.TextArea placeholder="Please enter" maxLength={1000} showCount rows={7} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}

export default GuarantiesTextFields;
